import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: grid;
  grid-row-gap: 4px;

  button {
    width: 130px;
  }

  & > span:last-of-type {
    margin-bottom: 6px;
  }
`
